import {PROPERTY_SELECTOR_SIGIL} from '../constants';
import isSelectableProperty from './isSelectableProperty';
/**
 * Create a function for getting components affected by a property name and source component id
 * @function createGetAffected
 * @private
 *
 * @param {Object} mappings - A object that will contain mappings
 * @returns {function} - A function for getting components affected by a property name and source component id
 */
export default mappings =>
	function getAffected(propertyName, providerId, componentRegistry, includeSource = true) {
		const sourceAffected = includeSource
			? {[`${providerId}${PROPERTY_SELECTOR_SIGIL}${propertyName}`]: ''}
			: {};
		let componentsAffected = {
			...mappings[`${providerId}${PROPERTY_SELECTOR_SIGIL}${propertyName}`]
		};

		if (!Object.keys(componentsAffected).length) return sourceAffected;

		if (!isSelectableProperty(componentRegistry, providerId, propertyName)) return sourceAffected;

		(function getAffectedSelectorChain(componentMap) {
			for (const selectorMap in componentMap) {
				if (mappings[selectorMap]) {
					componentsAffected = {
						...componentsAffected,
						...mappings[selectorMap]
					};
					getAffectedSelectorChain(mappings[selectorMap]);
				}
			}
		})(componentsAffected);

		return {
			...sourceAffected,
			...componentsAffected
		};
	};
